import { useContext } from 'react';

import { type ModalContextType,ModalsContext } from '../contexts/modals.context';

export const useModals = (): ModalContextType => {
    const context = useContext(ModalsContext);
    if (!context) {
        throw new Error('useModals must be used within a ToastProvider');
    }
    return context;
};
